import { useNavigate, useLocation } from "react-router-dom";
import { Calendar, MessageCircle } from "lucide-react";
import { openWhatsApp } from "@/data/menzy";

export const MobileBookBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const onBookings = location.pathname === "/bookings";

  const handleBook = () => {
    if (onBookings) {
      document.getElementById("booking-panel")?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/bookings");
    }
  };

  return (
    <div className="sm:hidden fixed bottom-0 inset-x-0 z-50 px-3 pb-3 pt-2 bg-gradient-to-t from-[#09090b] via-[#09090b]/95 to-transparent">
      <div className="flex items-center gap-2.5">
        <button
          onClick={handleBook}
          data-testid="mobile-book-bar-button"
          className="flex-1 gold-surface text-[#0b0b0c] font-extrabold uppercase tracking-wide text-sm py-3.5 rounded-full flex items-center justify-center gap-2 shadow-[0_0_24px_rgba(212,175,55,0.45)]"
        >
          <Calendar className="h-5 w-5" strokeWidth={2.5} />
          Book Appointment
        </button>
        <button
          onClick={() => openWhatsApp("Hi MENZY! I have a question about booking.")}
          data-testid="mobile-contact-button"
          aria-label="Contact Menzy on WhatsApp"
          className="h-[52px] w-[52px] rounded-full border border-[#d4af37]/50 bg-[#121215] flex items-center justify-center text-[#f4d160]"
        >
          <MessageCircle className="h-6 w-6" />
        </button>
      </div>
    </div>
  );
};
